(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ShowcasesFlyersController', ShowcasesFlyersController);



    function ShowcasesFlyersController($localStorage, $state, $stateParams, $scope, $window, $q, $rootScope, paginationConstants, $translate, FlyersService, FlyerCategoryService,
                                       FlyersCurrencyValue, ShowcasesService, toastr, BrandService, $uibModal, StoreService, systemConstants, Principal, MODAL_CONTENT_TYPES) {


        var vm = this;
        vm.$onInit = init;
        var storeId = $localStorage.defaultStore.storeId;
        var userId = $localStorage.userId;
        var listFilterLocalStorageKey = 'listFilter_' + userId + '_' + storeId;
        var filterLocalStorageKey = 'filter_' + userId + '_' + storeId;
        var isListViewLocalStorageKey = 'isListView_' + userId + '_' + storeId;

        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.maxSize = 5;
        vm.totalFlyers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.defaultSortOption = paginationConstants.hubSortOptions[$translate.use().toLowerCase()][0];

        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.isHubContext = $localStorage.defaultStore.hubContext;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };

        vm.listFilter = {
            activated: null,
            hasInventory: true,
            text: '',
            sortBy: vm.defaultSortOption.value,
            sortDirection: vm.defaultSortOption.direction
        };

        vm.bedrooms = [
            {id: 1, label: "1", value: 1 },
            {id: 2, label: "2", value: 2 },
            {id: 3, label: "3", value: 3 },
            {id: 4, label: "4", value: 4 },
            {id: 5, label: "5+", value: 5 },
        ];

        vm.selectedSortByOption = "";


        vm.loadFlyers = function (page, reset) {
            loadFlyers();
        };

        vm.isOpenCalendarStart = false;
        vm.isOpenCalendarExpire = false;

        vm.inactiveArray = [];

        vm.flyersFiltered = [];
        vm.page = 0;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.hasNextPage = false;
        vm.busy = false;

        vm.brands = [];
        vm.brandGroups = {};
        vm.selectedAll = false;
        vm.sizes = [];
        vm.colors = [];
        vm.numberFilterSelected = 0;
        vm.selectedFlyers = [];
        vm.numberFilterSelected = 0;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;

        vm.isListView =  $localStorage[isListViewLocalStorageKey] === undefined ? true : $localStorage[isListViewLocalStorageKey];

        function init() {
            if(vm.isImmoContext) {
                vm.sortOptions = paginationConstants.hubSortOptions[$translate.use().toLowerCase()].filter(function (type) {
                    return type.value !== "isBasic" && type.value !== "discountValue";
                });
            } else {
                vm.sortOptions = paginationConstants.hubSortOptions[$translate.use().toLowerCase()];
            }
        }

        function updateListView() {
            if ($window.innerWidth <= 768) {
                vm.isListView = true
                $localStorage[isListViewLocalStorageKey] = vm.isListView;
            }
        }

        updateListView();

        angular.element($window).on('resize', function () {
            $scope.$apply(updateListView);
        });

        function clearPaginationInfo() {
            // Turn to 0 the page to give right page on pageable
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };
        }

        vm.onChangeItemsPerPage = function (newValue) {
            vm.numPerPage = newValue;
            vm.changePage();
        };

        vm.changePage = function () {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;
            vm.paginationOptions.size = vm.numPerPage;

            loadFlyers();
            vm.startRegistry = begin + 1;
            vm.endRegistry = Math.min(end, vm.totalFlyers);
        }


        vm.onSelectedSortOption = function (newValue) {
            clearPaginationInfo();
            vm.selectedSortByOption = newValue;
            vm.listFilter.sortBy = vm.selectedSortByOption.value;
            vm.listFilter.sortDirection = vm.selectedSortByOption.direction;
            loadFlyers();
        }

        vm.loadFilter = function (filterType, listKey, singleKey, valueKey) {
            if (vm.filters[filterType].length > 0) {
                var formatedList = vm.filters[filterType].map(function (item) {
                    return item[valueKey];
                });

                vm.listFilter[listKey] = formatedList;

                if (singleKey && formatedList.length > 0) {
                    vm.listFilter[singleKey] = formatedList[0];
                }
            } else {
                delete vm.listFilter[listKey];
                if (singleKey) {
                    delete vm.listFilter[singleKey];
                }
            }
            clearPaginationInfo();
            loadFlyers();
        };

        vm.loadFilterRange = function () {
            if(vm.filters.minValue && vm.filters.maxValue) {
                vm.listFilter.minValue = vm.filters.minValue;
                vm.listFilter.maxValue = vm.filters.maxValue;
            } else {
                delete vm.listFilter.minValue;
                delete vm.listFilter.maxValue;
            }
            clearPaginationInfo();
            loadFlyers();
        }

        loadAll();

        vm.refreshSelectedFlyers = function(flyer) {

            var isAlreadySelected = vm.selectedFlyers.some(function(selected) {
                return selected.flyerId === flyer.id;
            });

            if (isAlreadySelected) {
                vm.selectedFlyers = vm.selectedFlyers.filter(function(selected) {
                    return selected.flyerId !== flyer.id;
                });
                flyer.isSelected = false;
            } else {
                flyer.isSelected = true;
                vm.selectedFlyers.push({
                    flyerId: flyer.id,
                    position: vm.selectedFlyers.length + 1
                });
            }

            vm.selectedAll = vm.flyersFiltered.length > 0;
            vm.flyersFiltered.forEach(function(filteredFlyer) {
                filteredFlyer.isSelected = vm.selectedFlyers.some(function(selected) {
                    return selected.flyerId === filteredFlyer.id;
                });

                if (!filteredFlyer.isSelected) {
                    vm.selectedAll = false;
                }
            });

            vm.changeFlyerSelected(flyer);
        };

        vm.existsSelectedItems = function () {
            return vm.selectedFlyers.length >= 1;
        };

        vm.checkIfFlyerSelected = function(flyer) {
            if (vm.flyersMap) {
                return angular.isDefined(vm.flyersMap[flyer.id]);
            }

            for (var i = 0; i < vm.selectedFlyers.length; i++) {
                if (vm.selectedFlyers[i].flyerId === flyer.id) {
                    return true;
                }
            }
            return false;
        };

        function loadAll() {
            vm.isLoading = true;

            FlyerCategoryService.listCategoriesByCurrentStore($translate.use(), $localStorage.defaultStore.storeId).then(function(response) {
                vm.categories = response.data;
            });

            ShowcasesService.getShowcase($stateParams.showcaseId, $stateParams.ownerId).then(function(data) {

                getConfigurationsValues();

                vm.showcase = data;
                loadTemplate();
                vm.listFilter.storeId = vm.showcase.ownerId;
                vm.selectedFlyers = vm.showcase.flyers.map(function(flyer, index) {
                    return {
                        flyerId: flyer.id,
                        position: index + 1 // Mantém a posição sequencial
                    };
                });
                BrandService.getBrandsByCurrentStore().then(function(response) {
                    vm.brands = response.data;
                    loadFlyers();
                });
            });

            FlyersService.getAllFiltersFlyer().then(function (response) {
                vm.colors = response.data.colors;
                vm.sizes = response.data.sizes;
            });
        }

        function loadTemplate() {
            ShowcasesService.getTemplate(vm.showcase.showcaseTemplateId).then(function(response) {
                vm.maxFlyersPerShowcase =  response.quantityOfRows * (12/response.row.items[0].size);;
            });
        }

        vm.reset = function reset() {
            vm.page = 0;
            vm.flyersFiltered = [];
        };

        vm.changePage = function () {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
            end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;
            vm.paginationOptions.size = vm.numPerPage;

            loadFlyers();
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;
        };

        vm.changeDisplayType = function () {
            vm.isListView = !vm.isListView;
            $localStorage[isListViewLocalStorageKey] = vm.isListView;
        };

        vm.currencyConfiguration = getCurrencyListConfiguration();

        function loadFlyers() {
            if(vm.busy) return;
            vm.busy = true;

            if (!vm.listFilter.colors || !(vm.listFilter.colors.length > 0)) {
                delete vm.listFilter.colors
            }

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("launch")) {
                vm.listFilter.launch = true;
            } else {
                delete vm.listFilter.launch;
            }

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("basic")) {
                vm.listFilter.basic = true;
            } else {
                delete vm.listFilter.basic;
            }


            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("delivered")) {
                vm.listFilter.delivered = true;
            } else {
                delete vm.listFilter.delivered;
            }

            if (!vm.listFilter.colors || !(vm.listFilter.colors.length > 0)) {
                delete vm.listFilter.colors
            }

            if (!vm.listFilter.sizes || !(vm.listFilter.sizes.length > 0)) {
                delete vm.listFilter.sizes
            }

            if (!vm.listFilter.genders || !(vm.listFilter.genders.length > 0)) {
                delete vm.listFilter.genders
            }

            if (vm.numberFilterSelected === 0 && vm.listFilter.brand && vm.listFilter.brand !== '' && vm.listFilter.text === '') {
                if (!vm.listFilter.brands || vm.listFilter.brands.length === 0) {
                    vm.listFilter.brands = [vm.listFilter.brand];
                }
            }

            if (vm.numberFilterSelected === 0 && vm.listFilter.categoryKey && vm.listFilter.categoryKey !== '' && vm.listFilter.text === '') {
                vm.listFilter.categoryKeys = [vm.listFilter.categoryKey]
            } else if (vm.filters.categories.length > 0) {
                vm.listFilter.categoryKey = vm.listFilter.categoryKeys[0]
            } else {
                delete vm.listFilter.categoryKeys
            }

            getFiltersNumber();

            FlyersService.listFlyersPage(vm.paginationOptions, vm.listFilter, onSuccess, onError);

            function onSuccess(response, headers) {
                var data = response.data.content;
                vm.busy = false;
                vm.totalFlyers = headers('X-Total-Count');
                vm.flyersFiltered = data.length <= 0 ? [] : data;

                for (var i = 0; i < data.length; i++) {
                    vm.getCategoryName(data[i]);
                }

                vm.flyersFiltered = vm.flyersFiltered.map(function (flyer) {
                    vm.getCategoryName(flyer);
                    flyer.currencyInstance = vm.currencyConfiguration[flyer.currency];
                    return flyer;
                });

                vm.isLoading = false;
                reduceFlyersToMap();
                refreshInactiveBoxArray();

                vm.makeBrandGroups();
                vm.makeCategoryGroups();
                vm.refreshFlyersSelected();
            }

            vm.makeBrandGroups = function() {
                vm.brandGroups = {};
                vm.showcase.flyers.forEach(function(flyer) {
                    if(flyer.brand){
                        vm.brandGroups[flyer.brand] = vm.brandGroups[flyer.brand] ? vm.brandGroups[flyer.brand] + 1 : 1;
                    }
                });
            }

            vm.makeCategoryGroups = function() {
                vm.categoryGroups = {};
                vm.showcase.flyers.forEach(function(flyer) {
                    if(flyer.category){
                        vm.categoryGroups[flyer.category] = vm.categoryGroups[flyer.category] ? vm.categoryGroups[flyer.category] + 1 : 1;
                    }
                });
            }

            function onError() {
                vm.busy = false;
                toastr.error($translate.instant('flyers.messages.load.error'));
            }
        }

        function refreshInactiveBoxArray(number) {
            vm.flyersStatus = [];
            var qtdActive = vm.showcase.flyers.length;
            for (var i = 0; i < vm.maxFlyersPerShowcase; i++) {
                if (qtdActive >= 1) {
                    vm.flyersStatus.push({
                        status: true
                    });
                } else {
                    vm.flyersStatus.push({
                        status: false
                    });
                }
                qtdActive--;
            }
        }

        function reduceFlyersToMap() {
            var index = 0;
            vm.flyersMap = vm.showcase.flyers.reduce(function(map, flyer) {
                map[flyer.id] = {
                    name: flyer.name,
                    pos: index
                };
                index++;
                return map;
            }, {})
        }

        vm.getCountSelectedByBrand = function(brand) {
            return vm.brandGroups[brand];
        };

        vm.tabClick = function(brand){
            vm.loadingTab = true;

            // Erases the offer list
            vm.flyersFiltered = [];

            // Turn to 0 the page to give right page on pageable
            vm.page = 0;

            // loadOffers
            loadFlyers();

        };

        vm.changeFlyerSelected = function(flyer) {
            if (vm.flyersMap) {
                if (vm.flyersMap[flyer.id]) {
                    vm.showcase.flyers.splice(vm.flyersMap[flyer.id].pos, 1);
                    reduceFlyersToMap();
                } else {
                    flyer.position = vm.showcase.flyers.length + 1;
                    vm.showcase.flyers.splice(0, 0, flyer);
                    reduceFlyersToMap();
                }
            } else {
                vm.showcase.flyers.splice(0, 0, flyer);
                reduceFlyersToMap();
            }
            refreshInactiveBoxArray();
            vm.refreshFlyersSelected()
        };

        vm.refreshFlyersSelected = function() {
            vm.makeBrandGroups();
            vm.makeCategoryGroups();
        };

        vm.getCategoryName = function(flyer) {
            var category = _.find(vm.categories, function(el) {return el.key === flyer.categoryKey});
            if (category) {
                flyer.category = category.title;
            }
        };

        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        };

        vm.checkFlyerIsSelected = function(flyer) {
            if (vm.flyersMap) {
                return angular.isDefined(vm.flyersMap[flyer.id]);
            }
        };

        vm.hasActiveFilter = function() {
            return ((vm.numberFilterSelected && vm.numberFilterSelected > 0) || (vm.listFilter.text && vm.listFilter.text !== ''));
        };

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        };

        function checkIsListAll() {
            vm.flyersFiltered = [];
            if (!vm.filters.inactive && !vm.filters.active) {
                vm.listFilter.status = null;
            }
            loadFlyers();

        }

        vm.changeStatusFilterToActive = function() {
            if (vm.filters.active) {
                vm.filters.inactive = false;
                vm.listFilter.status = "ACTIVATED";
            }
            checkIsListAll();
        };

        vm.changeStatusFilterToInactive = function() {
            if (vm.filters.inactive) {
                vm.filters.active = false;
                vm.listFilter.status = "DEACTIVATED";
            }
            checkIsListAll();
        }

        vm.openCalendarStart = function(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarStart = true;
        };

        vm.openCalendarExpire = function(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarExpire = true;
        };

        vm.saveShowcase = function(isRedirectToShowcaseScreen) {
            vm.showcase.flyers = vm.selectedFlyers;
            $q.all(vm.showcase.flyers).then(function(data) {
                ShowcasesService.updateShowcase(vm.showcase).then(function(data) {
                    if (isRedirectToShowcaseScreen) {
                        $state.go('showcases.edit', {
                            showcaseId: data.id
                        });
                    }
                });
            });
        }

        function getDefaultFilter() {
            setTimeout(function() {
                //load default filter
                vm.flyersFiltered = [];
                delete vm.listFilter.categoryKey;
                delete vm.listFilter.categoryKeys;
                delete vm.listFilter.brand;
                delete vm.listFilter.brands;
                loadAll();
            }, 1000);
        }

        function getConfigurationsValues() {
            vm.configurations = [
                {id: 1, label: "flyers.new.form.configurations.launch", code: "launch"},
                {id: 2, label: vm.getTranslateKey('flyers.new.form.configurations.basic'), code: "basic"}
            ];

            if (vm.isImmoContext) {
                vm.configurations.push(
                    {id: 3, label: "flyers.new.form.configurations.delivered", code: "delivered"}
                );
            }
        }

        function getFiltersNumber() {
            vm.numberFilterSelected = vm.filters.categories.length + vm.filters.brands.length + vm.filters.region.length +
                vm.filters.colors.length + vm.filters.sizes.length + vm.filters.genders.length +
                vm.filters.configurations.length + (Array.isArray(vm.filters.bedrooms) ? vm.filters.bedrooms.length : 0) +
                (vm.filters.minValue && vm.filters.maxValue ? 1 : 0);
        }

        vm.filters = {
            region: [],
            categories: [],
            brands: [],
            colors: [],
            sizes: [],
            genders: [],
            bedrooms: [],
            configurations: [],
            hasInventory: true,
            minValue: null,
            maxValue: null
        };

        vm.openFiltersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    options: function () {
                        return {
                            categories: vm.categories,
                            brands: vm.brands,
                            colors: vm.colors,
                            sizes: vm.sizes,
                            canChangeView: false
                        }
                    },
                    filters: function () {
                        return vm.filters
                    },
                    list: function () {
                        return vm.listFilter
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.numberFilterSelected = response.totalFilters;

                    vm.filters = response.selectedFilters;
                    if (response.totalFilters === 0) {
                        delete vm.listFilter.categoryKey;
                        delete vm.listFilter.categoryKeys;
                        vm.listFilter.brands = [vm.listFilter.brand];
                    } else
                        vm.listFilter = response.listFilter;
                    loadFlyers();
                }
            });
        }

        vm.withoutStockTooltip = function (item) {
            return item.inventory <= 0 && item.inventory != null ? $translate.instant('flyers.offerList.without-stock') : ''
        }

        vm.unlimitedStock = function (item) {
            return item.inventory != null ? item.inventory : $translate.instant('flyers.offerList.unlimited-stock');
        }

        function loadBrandsAndCategories() {
            setTimeout(function () {
                //load default filter
                getCategories();
                if (vm.isHubContext) {
                    loadBrands();
                } else {
                    getBrands();
                }
            }, 1000);
        }


        vm.openFiltersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
                resolve: {
                    content: function () {
                        return {
                            title: $translate.instant('flyers.filters.modalTitle'),
                            cancelButtonText: $translate.instant('flyers.button.cancel'),
                            confirmButtonText: $translate.instant('flyers.filters.apply'),
                            options: {
                                categories: vm.categories,
                                brands: vm.brands,
                                colors: vm.colors,
                                sizes: vm.sizes,
                                bedrooms: vm.bedrooms,
                                bathrooms: vm.bathrooms,
                                parkingSpots: vm.parkingSpots,
                                configurations: vm.configurations,
                                clearFilters: vm.clearFilters,
                                itemsPerPageOptions: vm.itemsPerPageOptions,
                                sortOptions: vm.sortOptions,
                                numPerPage: vm.numPerPage,
                                selectedSort: vm.selectedSortByOption
                            },
                            filters: vm.filters,
                            list: vm.listFilter,
                            isImmoContext: vm.isImmoContext,
                            type: MODAL_CONTENT_TYPES.FILTERS
                        }
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.filters = response.selectedFilters;
                    if (vm.numberFilterSelected === 0) {
                        loadBrandsAndCategories();
                    } else
                        vm.listFilter = response.listFilter;
                    clearPaginationInfo();
                    loadFlyers();
                }
            });
        }
    }
})();
